// extracted by mini-css-extract-plugin
export var buttons = "_b3-0";
export var buttonsActive = "_b3-h";
export var cancelConfirm = "_b3-1";
export var closeButton = "_b3-2";
export var column = "_b3-3";
export var container = "_b3-4";
export var detailHeader = "_b3-6";
export var detailTitle = "_b3-7";
export var detailsContent = "_b3-5";
export var header = "_b3-8";
export var headerWithClose = "_b3-9";
export var icon = "_b3-a";
export var infoIcon = "_b3-c";
export var informationContainer = "_b3-b";
export var sideDrawer = "_b3-d";
export var sideDrawerOpen = "_b3-e";
export var stickyFooter = "_b3-f";
export var typeOption = "_b3-g";